import React, {Component} from 'react';
import styles from './PropertyCategoryRibbon.scss';
import PropTypes from 'prop-types';

class PropertyCategoryRibbon extends Component {
  constructor(props) {
    super(props);
    this.categoryList = {
      'RentalListing': {
        'text': 'for rent',
        'class': 'forRent',
      },
      'SaleListing': {
        'text': 'for sale',
        'class': 'forSale',
      },
      'Property': {
        'text': 'off-market',
        'class': 'propertyReport'
      },
      'RecentlySold': {
        'text': 'Sold',
        'class': 'recentlySold'
      },
    };
  }

  render() {
    let text = '';
    let className = '';
    if (this.categoryList[this.props.category] && !this.props.isRecentlySold) {
      text = this.categoryList[this.props.category]['text'];
      className = this.categoryList[this.props.category]['class'];
    } else {
      text = this.categoryList['RecentlySold']['text'];
      className = this.categoryList['RecentlySold']['class'];
    }
    return (
      <div style={this.props.customStyle} className={'pt-1 pb-1 pl-4 pr-4 text-uppercase text-center ' + styles.wrapper + ' ' + styles[className]}>
        {text}
      </div>
    );
  }
}

PropertyCategoryRibbon.propTypes = {
  category: PropTypes.string.isRequired,
  isRecentlySold: PropTypes.bool,
  customStyle: PropTypes.object,
};


export default PropertyCategoryRibbon;
